
<template>
    <ul class="preview-list">
        <slot></slot>
    </ul>
</template>

<script>
import { ContainerMixin } from 'vue-slicksort';
export default {
    mixins: [ContainerMixin]
}
</script>



// WEBPACK FOOTER //
// PreviewList.vue?1d68437e